module.exports = __webpack_public_path__ + "static/media/UniNeueBold-Italic.eac75a3e.woff";